let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("b6l47"), load("e08m0"), load("hXFaG"), load("1giye"), load("7Q0UC"), load("6vOHT")]).then(() => parcelRequire('diitp'));